const toneMap: Record<string, string> = {
  approved: "bg-accent-100 text-accent-900",
  verified: "bg-accent-100 text-accent-900",
  paid: "bg-accent-100 text-accent-900",
  active: "bg-accent-100 text-accent-900",
  published: "bg-accent-100 text-accent-900",
  won: "bg-accent-100 text-accent-900",
  pending: "bg-primary-100 text-primary-900",
  unpaid: "bg-primary-100 text-primary-900",
  scheduled: "bg-primary-100 text-primary-900",
  new: "bg-primary-100 text-primary-900",
  qualified: "bg-primary-100 text-primary-900",
  trialing: "bg-primary-100 text-primary-900",
  contacted: "bg-background-200 text-foreground-700",
  draft: "bg-background-200 text-foreground-700",
  paused: "bg-background-200 text-foreground-700",
  cancelled: "bg-background-200 text-foreground-700",
  hidden: "bg-background-200 text-foreground-700",
  expired: "bg-background-200 text-foreground-700",
  rejected: "bg-secondary-100 text-secondary-900",
  failed: "bg-secondary-100 text-secondary-900",
  overdue: "bg-secondary-100 text-secondary-900",
  refunded: "bg-secondary-100 text-secondary-900",
  lost: "bg-secondary-100 text-secondary-900",
  suspended: "bg-secondary-100 text-secondary-900",
  past_due: "bg-secondary-100 text-secondary-900",
};

const iconMap: Record<string, string> = {
  approved: "ri-checkbox-circle-fill",
  verified: "ri-checkbox-circle-fill",
  paid: "ri-checkbox-circle-fill",
  active: "ri-checkbox-circle-fill",
  published: "ri-checkbox-circle-fill",
  won: "ri-trophy-line",
  pending: "ri-time-line",
  unpaid: "ri-time-line",
  scheduled: "ri-calendar-line",
  new: "ri-sparkling-fill",
  qualified: "ri-user-follow-line",
  trialing: "ri-flask-line",
  contacted: "ri-phone-line",
  draft: "ri-draft-line",
  paused: "ri-pause-circle-line",
  cancelled: "ri-close-circle-line",
  hidden: "ri-eye-off-line",
  expired: "ri-timer-line",
  rejected: "ri-close-circle-fill",
  failed: "ri-close-circle-fill",
  overdue: "ri-alarm-warning-line",
  refunded: "ri-refund-2-line",
  lost: "ri-emotion-sad-line",
  suspended: "ri-forbid-line",
  past_due: "ri-error-warning-line",
};

export default function StatusBadge({ status }: { status: string }) {
  const key = status.toLowerCase();
  const tone = toneMap[key] ?? "bg-background-200 text-foreground-700";
  const icon = iconMap[key] ?? "ri-circle-fill";
  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-bold capitalize ${tone}`}>
      <i className={icon}></i> {status}
    </span>
  );
}